import { AfterViewInit, Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TablesDataSource, TablesItem } from './tables-datasource';
import { MatDialog } from '@angular/material/dialog';
import {CrearComponent} from '../../aplicaciones/crear/crear.component';
import {TableAdminComponent} from './table-admin/table-admin.component';
import { ConsumeCredencialesService } from '../servicio/consume-credenciales.service';
import { MensajeService } from '../servicio/mensaje.service';
import { SpinnerService } from 'src/app/spinner.service';
import { TablesService } from './tables.service';
import { DataSource } from '@angular/cdk/table';
@Component({
  selector: 'app-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss']
})
export class TablesComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() params: any = {}; 
  // Titulos de las columnas de la tabla
  @Input() columns : any = []; 
   // Recurso en el back que se va consumir
  @Input() recurso : string;
  // Elemento que lanzara los eventos del componente padra del datable.
  @Input() targetTrigger : any; 
  @Input() nombreTable :string ;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['id_aplicacion', 'nombre', 'estadasdfos', 'acciones'];

  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog,
              private cred_ser : ConsumeCredencialesService,
              private msg_serv : MensajeService,
              private spiner : SpinnerService,
              private tbserv : TablesService){}

  ngOnDestroy(): void {
    delete this.tbserv.tablas[this.nombreTable];
  }

  ngOnInit() {
    this.displayedColumns = this.columns;
    this.tbserv.tablas[this.nombreTable] = this;
  }
  
  async ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.cargar_datos(this.params);
  }

  /**
   * 
   * @param evento evento que ejecutara la funcion
   * @param json_parametros parametro que se el enviaran al evento.
   */
  ejecutarFuncion(evento : string, json_parametros : any, row) {
    
    this.tbserv.params_event = json_parametros;
    this.tbserv.fila_seleccionada = this.dataSource.data.indexOf(row);
    this.targetTrigger.dispatchEvent(new Event(evento, { bubbles: true }));

  }

  abrirTablaAdmin() {
    const dialogRef = this.dialog.open(TableAdminComponent, {
      width: '500px',
      height: '500px'
    });
  }

  async cargar_datos(params,recurso?, columnas?){

    this.recurso = recurso? recurso : this.recurso;
    this.columns = columnas? columnas : this.columns;

    if (params && this.recurso){

      this.params =params
      this.obtener_data()
    }
  }

  public async obtener_data(){
    const promesa =  this.cred_ser.get(this.recurso, this.params).toPromise();

    await promesa.then(
      (data: any)=>{
        this.spiner.spin$.next(false);
        if (data.data){
          this.dataSource.data= data.data;
        }else if(data.code > 0){
          this.msg_serv.ver_mensaje(data.msg, '', this.msg_serv.TIPO_ERROR);
        }else{
          let str_msg ='No se recibieron datos para mostrar en la tabla';
          this.msg_serv.ver_mensaje(str_msg, '', this.msg_serv.TIPO_ERROR);
        }
    }
    );

  }

  public data_offline(data){
    this.displayedColumns;
    this.dataSource.data = data;
  }

  /**
   * 
   * @param columna columna a actualizar
   * @param valor nuevo valor para la columna
   */
  public actualizar_fila_actual(columna, valor){
    this.dataSource.data[this.tbserv.fila_seleccionada][columna] = valor;
  }

}
